/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
document.addEventListener('DOMContentLoaded', () => {
  const types = ['path', 'polygon']
  // Creating a tooltip element when the DOM is fully loaded ensures that the tooltip is only created
  // once all elements are available, preventing issues with trying to append to an incomplete DOM.
  function createTooltip() {
    const tooltip = document.createElement('div')
    tooltip.classList.add('tooltip') // Adding a class for consistent styling through CSS.
    document.body.appendChild(tooltip) // Append the tooltip to the body to ensure it is always on top.

    // Function to show the tooltip with the provided text.
    // It sets the inner text and makes the tooltip visible.
    function showTooltip(event, text) {
      tooltip.innerText = text // Securely setting text content to avoid XSS.
      tooltip.style.display = 'block' // Make the tooltip visible.
      moveTooltip(event) // Position the tooltip relative to the cursor position.
    }

    // Function to move the tooltip along with the cursor.
    // Padding ensures the tooltip does not overlap the cursor.
    function moveTooltip(event) {
      const padding = 8 // Padding to prevent overlap with the cursor.
      tooltip.style.left = `${event.pageX + padding}px` // Positioning tooltip relative to cursor's X.
      tooltip.style.top = `${event.pageY + padding}px` // Positioning tooltip relative to cursor's Y.
    }

    // Function to hide the tooltip by setting its display style to 'none'.
    // This is important to ensure the tooltip is not visible when not needed.
    function hideTooltip() {
      tooltip.style.display = 'none' // Hide the tooltip.
    }

    // Return an object with methods to show, move, and hide the tooltip.
    // This encapsulates the tooltip logic and exposes only the necessary methods.
    return {
      show: showTooltip,
      move: moveTooltip,
      hide: hideTooltip,
    }
  }

  // Initialize the tooltip functionality.
  const tooltip = createTooltip()
  let tooltipActive = false // Flag to check if tooltip is active

  function handleMouseOver(event) {
    if (
      types.includes(event.target.tagName.toLowerCase()) &&
      event.target.classList.contains('highlight')
    ) {
      const countryName = event.target.getAttribute('title')
      tooltip.show(event, countryName)
      tooltipActive = true // Set the flag to true when tooltip is active
    }
  }

  function handleMouseMove(event) {
    if (tooltipActive) {
      // Only move tooltip if active
      tooltip.move(event)
    }
  }

  function handleMouseOut(event) {
    if (
      types.includes(event.target.tagName.toLowerCase()) &&
      event.target.classList.contains('highlight')
    ) {
      tooltip.hide()
      tooltipActive = false // Reset the flag when tooltip is hidden
    }
  }

  document.addEventListener('mouseover', handleMouseOver)
  document.addEventListener('mousemove', handleMouseMove)
  document.addEventListener('mouseout', handleMouseOut)
})
/* eslint-enable no-console */
